export default {
  plural: 'Twin-матеріали',
  createButton: 'Створити матеріал',
  createTitle: 'Додати матеріал',
  editTitle: 'Редагувати матеріал',
  deleteTitle: 'Видалити матеріал',
  deleteWarning: 'Ви впевнені, що хочете видалити цей матеріал?',
  company: 'Компанія',
  crmMaterial: 'CRM-матеріал',
  glbAsset: 'GLB-ассет',
  glbMaterialName: 'GLB-матеріал',
  swatchColor: 'Колір свотчу',
  materialGroup: 'Група матеріалу',
  noMaterials: 'Матеріалів поки немає',
  addMaterial: 'Додати матеріал',
  backendBlocked: 'Очікує підтримки бекенду',
  bulkAddButton: 'Масове додавання',
  bulkCreateTitle: 'Масове додавання матеріалів',
  crmMaterials: 'CRM-матеріали',
  noGroup: 'Без групи',
  searchPlaceholder: 'Пошук зони...',
  selectZone: 'Оберіть зону ліворуч, щоб налаштувати її матеріали',
  allowedCount: 'дозволено',
  zones: {
    plural: 'Zones',
    noZones: 'Зон поки немає — розпізнайте GLB-ассет з мешами twinZone',
    noTemplate: 'Немає шаблону зони — створіть, щоб зона стала доступна',
    noMaterials: 'Для цієї зони немає дозволених матеріалів',
    createTemplate: 'Створити шаблон',
    save: 'Зберегти',
    setDefault: 'За замовчуванням'
  }
};
